import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { AdvertisementStateModel } from 'models/setting/advertisement/advertisement.model';
import {
  activeAdvertisementAction,
  createAdvertisementAction,
  deleteAdvertisementAction,
  getAdvertisementAction,
  inactiveAdvertisementAction,
  listAdvertisementAction,
  updateAdvertisementAction,
} from './advertisement.action';

const initialState: AdvertisementStateModel = {
  advertisementListData: null,
  advertisementDetail: null,
  triggerSaveAdvertisement: null,

  loadingList: false,
  loadingDetail: false,
};

export const advertisementSlice = createSlice({
  name: 'advertisement',
  initialState,
  reducers: {
    setAdvertisementStateAction: (
      state,
      action: PayloadAction<Partial<AdvertisementStateModel>>,
    ) =>
      ({
        ...state,
        ...action?.payload,
      } as AdvertisementStateModel),
    resetAdvertisementStateAction: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdvertisementAction.pending, (state) => ({
        ...state,
        advertisementDetail: null,
        loadingDetail: true,
      }))
      .addCase(getAdvertisementAction.fulfilled, (state, { payload }) => ({
        ...state,
        advertisementDetail: payload?.data || null,
        loadingDetail: false,
      }))
      .addCase(getAdvertisementAction.rejected, (state) => ({
        ...state,
        advertisementDetail: null,
        loadingDetail: false,
      }))
      .addCase(listAdvertisementAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(listAdvertisementAction.fulfilled, (state, { payload }) => ({
        ...state,
        loadingList: false,
        advertisementListData: {
          items: payload?.data?.items || [],
          totalItems: payload?.data?.totalItems || 0,
          totalPages: payload?.data?.totalPages || 0,
        },
      }))
      .addCase(listAdvertisementAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(createAdvertisementAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisement: { id: uuidv4() },
      }))
      .addCase(updateAdvertisementAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisement: { id: uuidv4() },
      }))

      .addCase(deleteAdvertisementAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(deleteAdvertisementAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisement: { id: uuidv4() },
      }))
      .addCase(deleteAdvertisementAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(activeAdvertisementAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisement: { id: uuidv4() },
        loadingList: false,
      }))
      .addCase(inactiveAdvertisementAction.fulfilled, (state) => ({
        ...state,
        triggerSaveAdvertisement: { id: uuidv4() },
        loadingList: false,
      }));
  },
});

export const { setAdvertisementStateAction, resetAdvertisementStateAction } =
  advertisementSlice.actions;

export default advertisementSlice.reducer;
